<mat-card class="list-card flex-col flex">
    <mat-card-header>
        <div mat-card-avatar class="cb-card-avatar-icon mat-mdc-header-card-avatar">
            @if (mappedItem?.contacts?.length > 0) {
                <mat-icon class="cb-primary"> check_circle </mat-icon>
            }
            @if (mappedItem?.contacts?.length < 1) {
                <mat-icon class="cb-error"> error </mat-icon>
            }
        </div>
        <mat-card-title>1. Client Details</mat-card-title>
    </mat-card-header>
    @if (mappedItem?.contacts?.length > 0) {
        <mat-card-content class="start-start flex-col flex cb-margin-bottom-2x">
            @for (contact of sortedMappedItemContacts; track contact; let last = $last) {
                <div class="flex-col" style="width: 100%">
                    <mat-divider></mat-divider>
                    <div class="start-center flex-row" style="padding: 16px 0">
                        @if (isMainContact(contact) && !contact.incomplete) {
                            <mat-icon title="Main Contact" class="cb-accent">stars</mat-icon>
                        }
                        @if (!isMainContact(contact) && !contact.incomplete) {
                            <mat-icon title="Other Contact">radio_button_unchecked</mat-icon>
                        }
                        @if (contact.incomplete) {
                            <mat-icon class="cb-warn" title="Incomplete">warning</mat-icon>
                        }
                        <div class="flex-row flex" style="margin-left: 12px">
                            <div class="flex-col">
                                <span class="mat-body-strong">
                                    &nbsp;{{ contact.firstName }}&nbsp;{{ contact.lastName }}
                                </span>
                                @if (contact.preferredContactDetails) {
                                    <span class="mat-body-2 main-text"
                                        >{{
                                            getPreferredContactDetails(
                                                contact.preferredContactDetails
                                            )
                                        }}
                                        @if (contact.preferredContactDetails.length > maxLength) {
                                            <div class="additional-text">
                                                {{ contact.preferredContactDetails }}
                                            </div>
                                        }
                                    </span>
                                }
                            </div>
                        </div>
                        <span class="flex"></span>
                        <button [matMenuTriggerFor]="menu" mat-icon-button>
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            @if (canChangeMainContact() && !isMainContact(contact)) {
                                <button
                                    mat-menu-item
                                    (cbClick)="updateMainContact($event, contact)"
                                >
                                    <mat-icon>stars</mat-icon>
                                    &nbsp; Set as Main Contact
                                </button>
                            }
                            @if (canRemoveContact() && !isMainContact(contact)) {
                                <button mat-menu-item (cbClick)="removeContact($event, contact)">
                                    <mat-icon>remove_circle</mat-icon>
                                    &nbsp; Remove from Lead
                                </button>
                            }
                            <button mat-menu-item (cbClick)="viewContact(contact)">
                                <mat-icon>pageview</mat-icon>
                                &nbsp;View Contact
                            </button>
                            @if (canEditContact()) {
                                <button mat-menu-item (cbClick)="editContact(contact)">
                                    <mat-icon>edit</mat-icon>
                                    &nbsp;Edit Contact
                                </button>
                            }
                        </mat-menu>
                    </div>
                    @if (last) {
                        <div>
                            <mat-divider></mat-divider>
                        </div>
                    }
                </div>
            }
        </mat-card-content>
    }
    @if (canEdit && !mappedItem.isQualified()) {
        <div>
            <mat-divider class="card-divider"></mat-divider>
        </div>
    }
    @if (canEdit && !mappedItem.isQualified()) {
        <mat-card-actions class="end-center flex-row">
            @if (canAddContact()) {
                <button mat-stroked-button color="accent" (cbClick)="openAddContactDialog($event)">
                    <mat-icon>add</mat-icon>
                    &nbsp;Add Contact
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
